import { Maybe, ICarrierApplication } from 'types/graphqlTypes'
import { IShipmentBouncedCarrierFragment } from '../graphql/ShipmentBouncedCarrierFragment'

interface IGetBouncedCarrierAssignmentProps {
  optionCarrierApplicationId: Maybe<ICarrierApplication['id']>
  bouncedCarrierAssignments: Maybe<IShipmentBouncedCarrierFragment[]>
}

/**
 * Returns the matching CarrierAssignment from a list of bounced carrier assignments given a carrier application id
 * @returns getBouncedCarrierAssignment({ optionCarrierApplicationId: '123', bouncedCarrierAssignments: [{ id: '111', carrierApplication: { id: '123' } }] }) // { id: '111', carrierApplication: { id: '123' } }
 */
export const getBouncedCarrierAssignment = ({
  bouncedCarrierAssignments,
  optionCarrierApplicationId,
}: IGetBouncedCarrierAssignmentProps): Maybe<IShipmentBouncedCarrierFragment> => {
  if (!optionCarrierApplicationId) {
    return null
  }

  if (!bouncedCarrierAssignments || !bouncedCarrierAssignments.length) {
    return null
  }

  return bouncedCarrierAssignments.find(
    ({ carrierApplication }) => carrierApplication.id === optionCarrierApplicationId
  )
}
